export const assignRcsRouteToEnterpriseMutation = (builder) => ({
  assignRcsRouteToEnterprise: builder.mutation({
    query: (data) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/assign_rcs_route",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
    },
  }),
});
